import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdHome: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 20 19" fill="none" {...props}>
    <Path
      d="m18.85 7.819-1.92-1.493h-.002l-4.234-3.322-2.466-1.923a.383.383 0 0 0-.471 0L7.31 3.004l-4.233 3.3-1.923 1.517a.382.382 0 1 0 .473.6l1.303-1.026v9.833a1.452 1.452 0 0 0 1.45 1.45h11.243a1.452 1.452 0 0 0 1.45-1.45V7.409l1.305 1.015a.382.382 0 1 0 .47-.605ZM8.411 17.913v-3.114A1.301 1.301 0 0 1 9.71 13.5h.655a1.3 1.3 0 0 1 1.3 1.3v3.113H8.411Zm7.897-.685a.694.694 0 0 1-.685.685h-3.193v-3.114a2.067 2.067 0 0 0-2.065-2.064H9.71A2.067 2.067 0 0 0 7.646 14.8v3.113H4.381a.685.685 0 0 1-.685-.685V6.793l4.087-3.186 2.211-1.738 2.229 1.738 4.086 3.205v10.416Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.2}
    />
  </Svg>
);

export default PdHome;
